import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Trans } from "react-i18next";
import { ReactComponent as BackIcon } from "../../../../assets/img/leftArrow.svg";

import ActionButtons from "../ActionButtons";
import TelInput from "components/TelInput";
import { useStore } from "_Store";

const validationSchema = yup.object({
  idDepartment: yup.string().required("Veuillez sélectionner un département"),
  idCommune: yup.string().required("Veuillez sélectionner une commune"),
  idArrondissement: yup.string().required("Veuillez sélectionner un arrondissement"),
  idVillage: yup.string().required("Veuillez entrer un quartier/village").trim("Non valide, réessayer"),
   idEmail: yup
     .string()
     .email("Adresse mail non valide, réessayer")
     .required("Veuillez entrer une adresse mail"),
  idPhone: yup
    .number("Téléphone non valide, réessayer")
    .required("Veuillez entrer un numéro de téléphone")
    .min(6, "Non valide, réessayer"),
});

const ConseillerContact = ({ onSubmit, onBack, data: formData }) => {
  const [idError, setIdError] = React.useState(false);
  const [communes, setCommunes] = React.useState([]);
  const [departements, setDepartements] = React.useState([]);
  const [arrondissements, setAarrondissements] = React.useState([]);
  const {
    state: {
      utils: { directory },
    },
  } = useStore();

  const filterPhoneNumber = (number) => {
    if (number.substring(0, 4) === "+229") {
      return number.slice(4);
    }
    return number;
  };

  const formik = useFormik({
    initialValues: {
      ...{
        idDepartment: "",
        idCommune: "",
        idArrondissement: "",
        idVillage: "",
        idPhone: "",
        idEmail: "",
        ...formData,
      },
    },
    validationSchema,
    onSubmit: (vals) => {
      if (vals["idPhone"].substring(0, 4) !== "+229") {
        vals["idPhone"] = `+229${vals.idPhone}`;
      }
      onSubmit(vals);
      setTimeout(() => {}, 800);
    },
  });

  React.useEffect(() => {
    let dirc = [];
    let deps = directory
      .map((dep) => {
        return dep.departments.name;
      })
      .filter((v, i, a) => a.indexOf(v) === i);
    deps.forEach((dep) => {
      dirc.push({
        department: dep,
        communes: directory
          .filter((com) => {
           // console.log(com,'****** abomey-calavi crf')
            return com.departments.name === dep;
          })
          .map((com) => {
            return {
              commune: com.communeName,
              arrondissements: com.arrondissements[0]?.arrondissements,
            };
          }),
      });
    });
    setDepartements(dirc);

    if (formData?.idDepartment) {
      setCommunes(
        dirc.find((dep) => dep.department === formData?.idDepartment).communes
      );

      if (formData?.idCommune) {
        setAarrondissements(
          dirc
            .find((dep) => dep.department === formData?.idDepartment)
            .communes.find((com) => com.commune === formData?.idCommune)
            .arrondissements
        );
      }
    }
  }, [directory]);

  return (
    <div className="px-4 sm:px-0">
      <div className="flex flex-col justify-center py-16">
        <div className="relative">
          <div
            className="absolute -left-20 top-1/2 -translate-y-1/2 cursor-pointer"
            onClick={onBack}
          >
            <BackIcon />
          </div>
          <Typography variant="title">
            <Trans>formTitles.contactInformation</Trans>
          </Typography>
          <Typography variant="title" fontSize={20} fontWeight={200}>
              <div style={{ background: "darkred", color: "white" }} className="p-4 mt-4 text-left">
               <h4 style={{ color: "white" }}>Note</h4>
               <p style={{ color: "white" }}> 
                Notez que votre compte devra faire l'objet de validation avant que vous ne puissiez avoir accès aux differents services. <br/>
                Vous recevrez une reponse sous les 48 heures. Si non, veuillez contactez le support technique pour une prise en charge.
                </p>  
              </div>
          </Typography>
        </div>

        <form>
          <div className="mt-10">
            <div className="mb-6">
              <Typography fontSize={20} fontWeight={200}>
                Adresse
              </Typography>
            </div>
            <div className="grid sm:grid-cols-2 gap-y-6 sm:gap-x-9">
              <div className="">
                <FormControl
                  fullWidth
                  error={
                    formik.touched.idDepartment &&
                    Boolean(formik.errors.idDepartment)
                  }
                >
                  <InputLabel>Département</InputLabel>
                    <Select
                      name="idDepartment"
                      label="Département"
                      value={formik.values.idDepartment}
                      onChange={(e) => {
                        formik.handleChange(e);
                        setCommunes(
                          departements.find(
                            (dep) => dep.department === e.target.value
                          ).communes
                        );
                      }}
                    >
                      {departements.map((arr) => (
                        <MenuItem key={arr.department} value={arr.department}>
                          {arr.department}
                        </MenuItem>
                      ))}
                    </Select>
                  <FormHelperText>
                    {formik.touched.idDepartment && formik.errors.idDepartment}
                  </FormHelperText>
                </FormControl>
              </div>

              <div className="">
                <FormControl
                  fullWidth
                  error={
                    formik.touched.idCommune && Boolean(formik.errors.idCommune)
                  }
                >
                  <InputLabel>Commune</InputLabel>
                  <Select
                    name="idCommune"
                    label="idCommune"
                    disabled={communes.length === 0}
                    value={formik.values.idCommune}
                    onChange={(e) => {
                      formik.handleChange(e);
                      setAarrondissements(
                        departements
                          .find(
                            (dep) =>
                              dep.department === formik.values.idDepartment
                          )
                          .communes.find(
                            (com) => com.commune === e.target.value
                          ).arrondissements
                      );
                    }}
                  >
                    {communes.map((arr) => (
                      <MenuItem key={arr.commune} value={arr.commune}>
                        {arr.commune}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {formik.touched.idCommune && formik.errors.idCommune}
                  </FormHelperText>
                </FormControl>
              </div>

              <div className="">
                <FormControl
                  fullWidth
                  error={formik.touched.idArrondissement && Boolean(formik.errors.idArrondissement)}
                >
                  <InputLabel>Arrondissement</InputLabel>
                  <Select
                    name="idArrondissement"
                    label="Arrondissement"
                    value={formik.values.idArrondissement}
                    onChange={formik.handleChange}
                  >
                    {arrondissements.map((arr) => (
                      <MenuItem key={arr} value={arr}>
                        {arr}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {formik.touched.idArrondissement &&
                      formik.errors.idArrondissement}
                  </FormHelperText>
                </FormControl>
              </div>

              <div className="">
                <FormControl fullWidth>
                  <TextField
                    name="idVillage"
                    label="Quartier / Village"
                    value={formik.values.idVillage.trimStart()}
                    error={
                      formik.touched.idVillage &&
                      Boolean(formik.errors.idVillage)
                    }
                    helperText={
                      formik.touched.idVillage && formik.errors.idVillage
                    }
                    onChange={formik.handleChange}
                  />
                </FormControl>
              </div>
            </div>
          </div>

          <div className="mt-12">
            <div className="mb-6">
              <Typography fontSize={20} fontWeight={200}>
                Contacts
              </Typography>
            </div>
            <div className="grid sm:grid-cols-2 gap-y-6 sm:gap-x-9">
              <div className="">
                <FormControl fullWidth>
                  <TelInput
                    name="idPhone"
                    value={filterPhoneNumber(formik.values.idPhone)}
                    error={
                      formik.touched.idPhone && Boolean(formik.errors.idPhone)
                    }
                    helperText={formik.touched.idPhone && formik.errors.idPhone}
                    onChange={formik.handleChange}
                  />
                </FormControl>
              </div>
              <div className="">
                <FormControl fullWidth>
                  <TextField
                    name="idEmail"
                    label="E-mail"
                    type="email"
                    value={formik.values.idEmail.trim()}
                    error={
                      formik.touched.idEmail && Boolean(formik.errors.idEmail)
                    }
                    helperText={formik.touched.idEmail && formik.errors.idEmail}
                    onChange={formik.handleChange}
                  />
                </FormControl>
              </div>
            </div>
          </div>

          <div className="flex justify-end mt-20 gap-6">
            <ActionButtons onNextStep={formik.handleSubmit} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ConseillerContact;
